import React from 'react';
import PropTypes from 'prop-types';
import { safeConnect } from './../../tools/Utils';
import { isNullOrUndefined } from 'util';

export class _ReduxParallax extends React.Component
{

	state = {}
	holder = React.createRef();

	componentDidUpdate = (oldProps) =>
	{
		if(oldProps.isLoaded !== this.props.isLoaded)
		{
			this.initLocation();
		}
	}

	initLocation = () =>
	{
		const { top, height } = this.holder.current.getBoundingClientRect();
		if((top+height)!==0)
		{
			this.setState({initTop:top + this.props.scrollY, height:height})
			// this.top = top + this.props.scrollY;
			// this.height = height;
		}
	}

	defaultStyle = (displacement) =>
	{
		const {transform=''} = this.props

		if(typeof displacement === 'undefined')
		{
			return {transform: ` ${transform} translate3d(0px, 0px, 0px)`};
		}

		if(displacement === null)
		{
			return  {display:'none'}
		}

		return { position: 'absolute', transform: `${transform} translate3d(0px, ${displacement}px, 0px)` }

	}

	getDisplacement = () =>
	{
		
		if(!this.props.isLoaded)
		{
			return;
		}

		const element = this.holder.current;
		if(!element)
		{
			return;
		}

		const {initTop, height} = this.state

		if(typeof initTop === 'undefined')
		{
			return;
		}

		const {windowY, scrollY, start, end, linear=true, speed=1 } = this.props

		

		const top = windowY + scrollY - initTop  ;
		const center = top - height/2;
		const bottom = top - height;
		

		if(top<0||bottom>windowY)
		{
			return null;
		}


		if(typeof start === 'undefined' || typeof end === 'undefined')
		{

			return (initTop - (height*.5 )- scrollY) *speed;
		}

		const screenStart = (1-end)*windowY;
		const screenEnd = (1-start)*windowY;

		let displacement = 0;


		if(center<screenStart)
		{
			displacement = linear? screenStart-center : Math.pow(screenStart-center,2)
		}
		else if(center>screenEnd)
		{
			displacement = linear? screenEnd-center : -Math.pow(screenStart-center,2)
		}

		return displacement*speed;

	}
	render()
	{
		const displacement = this.getDisplacement();
		const cssStyle = typeof this.props.style === 'function'? this.props.style(displacement): this.defaultStyle(displacement);

		return (
			<React.Fragment>
				{this.props.children(this.holder, cssStyle, displacement)}
			</React.Fragment>
		);
	}
}

export const ReduxParallax = safeConnect(
	(state, ownProps) =>
	{	
		return {
			scrollY:state.window.scroll.y,
			windowY:state.window.size.height,
			isLoaded:state.window.isLoaded,
		};
	}
)(_ReduxParallax);
